<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { dateTimeFormat } from '@/utils/dateformat';
import { BILLING_CYCLE, unlockBizLicenseCount, ZOOM_MEETING_PRO_MIN_LICENSE } from '@/common/constants';

export default {
  name: 'Downgrade',
  mixins: [baseMixins],
  data() {
    return {
      showCategoryDesc: true,
      showPlanDetail: true,
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'basicConfig', 'assignInfo', 'plansofBizBundle', 'disableMonthly2AnnualTip']),
    showExploreLink() {
      return true;
    },
    supportMSQ() { return false; },
    maxHost() {
      return 9999;
    },
    minHost() {
      return this.minHostAndReason.minHost;
    },
    isNormalCase() {
      return true;
    },
    additionalSpans() {
      return {
        biz: [
          {
            value: ZOOM_MEETING_PRO_MIN_LICENSE,
            text: unlockBizLicenseCount ? this.$t('billing.zone.min_of_biz_1') : this.$t('billing.zone.min_of_biz_new', { number: 10 }),
            default: true,
          },
          {
            value: this.maxHost,
            text: this.$t('billing.zone.max_license_of_biz', [this.maxHost, this.maxHost + 1]),
          },
        ],
      }
    },
    couldBeRemovedAsAddonCard() {
      return false;
    },
    minHostAndReason() {
      let minHost = ZOOM_MEETING_PRO_MIN_LICENSE;
      const { assignedBizPlusLicenseQuantity, maxLicensesAddonPlan, boughtBizPlusPlan } = this.plansofBizBundle;
      const maxLicenseAddonLicense = get(maxLicensesAddonPlan, 'cartInfo.selected_number', 0);
      // add-on
      if (this.form.selectedNumber <= maxLicenseAddonLicense) {
        const maxLicenseAddonTypeNameKey = maxLicensesAddonPlan.typeNameKey;
        const maxLicenseAddonTypeName = this.$t(maxLicenseAddonTypeNameKey);
        return {
          reason: this.$t('billing.meeting_license_decrease_tips_need_decrease_addon', { product: maxLicenseAddonTypeName }),
          minHost: Math.max(maxLicenseAddonLicense, minHost)
        }
      }
      // assign info
      if (this.form.selectedNumber <= assignedBizPlusLicenseQuantity) {
        const needAssignTotalQuantity = assignedBizPlusLicenseQuantity - this.form.selectedNumber;
        const expireTime = boughtBizPlusPlan?.[0]?.cartInfo?.planExpireTime;
        if (needAssignTotalQuantity > 0) {
          return {
            minHost,
            reason: expireTime
            ? this.$t('billing.error.downgrade_alert_info', [needAssignTotalQuantity, dateTimeFormat(expireTime)])
            : this.$t('billing.error.downgrade_alert_info_no_date', [needAssignTotalQuantity])
          }
        }
      }
      return {
        reason: '',
        minHost
      }
    },
    licenseTips() {
      return this.minHostAndReason.reason;
    }
  },
  methods: {
    billingCycleDisabled({ billing_cycle }) {
      if (this.disableMonthly2AnnualTip && billing_cycle === BILLING_CYCLE.ANNUAL) {
        return this.disableMonthly2AnnualTip;
      }

      return this.getBillingCycleDisabledDesc(billing_cycle);
    },
  },
};
</script>
